import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {http} from '@/axios'
import store from '@/store'

const {languages, defaultLanguageCode} = LANGUAGES

const languagesCodes = languages.map(language => language.code)
const loadedLanguages = [] // our default language that is preloaded

Vue.use(VueI18n)


const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: defaultLanguageCode,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  //missing: (a, b) => {
  //  console.log(b)
  //}
})

setI18nLanguage(i18n.locale)

function setI18nLanguage(lang) {
  if (!languagesCodes.includes(lang)) return
  const langObj = getLangObjByCode(lang)
  if (i18n.locale !== lang) {
    i18n.locale = lang
    store.dispatch('reset')
  }

  document.querySelector('html').setAttribute('lang', `${lang}-${langObj.country_code}`)
  setLocaleToBrowserStorage(lang)
  return lang
}

function loadLanguageAsync(lang) {
  if (!lang) {
    lang = i18n.locale
  }

  if (!languagesCodes.includes(lang)) {
    return
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  store.commit('setPending', true)
  // If the language hasn't been loaded yet
  return http.get('/api/language/translations', {
    params: {
      lang: lang
    }
  }).then(({data}) => {
    i18n.setLocaleMessage(lang, data.data)
    loadedLanguages.push(lang)
    return setI18nLanguage(lang)
  }).finally(() => {
    store.commit('setPending', false)
  })
}

function getLocaleFromBrowser() {
  if (!window.navigator.language) return null

  let locale = window.navigator.language.split('-')
  if (locale[0]) locale[0] = locale[0].toLowerCase()
  if (locale[1]) locale[1] = locale[1].toLowerCase()

  for (let key of languagesCodes) {
    if (key === locale[0] || key === locale[1]) {
      return key
    }
  }
}

function setLocaleToBrowserStorage(locale) {
  localStorage.setItem('locale', locale)
}

function getLocaleFromBrowserStorage() {
  return localStorage.getItem('locale')
}

function getLocale() {
  let locationPathname = location.pathname
  if (locationPathname.startsWith('/')) {
    locationPathname = locationPathname.slice(1)
  }

  let locale = locationPathname.split('/')[0]
  if (languagesCodes.includes(locale)) {
    return locale
  }

  locale = getLocaleFromBrowserStorage()
  if (languagesCodes.includes(locale)) {
    return locale
  }

  locale = getLocaleFromBrowser()
  if (locale) {
    return locale
  }

  return defaultLanguageCode
}

function getLangObjByCode(lang) {
  let langObj = languages.find(item => item.code === lang)

  if (!langObj) {
    langObj = languages.find(item => item.code === defaultLanguageCode)
  }

  return langObj
}

function getLangObjByShowCode(lang) {
  return languages.find(item => item.show_code === lang)
}


export {
  languages,
  setI18nLanguage,
  loadLanguageAsync,
  getLangObjByCode,
  getLangObjByShowCode,
  getLocale
}
export default i18n
